import React from "react";
import { safeJSONParse } from "../../utils/jsonHelper";

const Recommendations = ({ comments, recommendations }) => {
  const normalize = (val) =>
    Array.isArray(val) ? val : safeJSONParse(val, []);

  const safeComments = normalize(comments);
  const safeRecommendations = normalize(recommendations);

  const hasComments = safeComments.length > 0;
  const hasRecommendations = safeRecommendations.length > 0;

  return (
    <div className="w-full bg-purple-50 rounded-lg p-4 lg:p-5 flex flex-col gap-6">
      <div>
        <h3 className="text-sm lg:text-base font-semibold text-gray-900 mb-3">
          Trade Call Logic
        </h3>
        {hasComments ? (
          <ul className="space-y-2">
            {safeComments.map((item, index) => (
              <li
                key={item.id || index}
                className="text-xs lg:text-sm text-gray-700 leading-relaxed"
              >
                • {item.text || ""}
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-xs lg:text-sm text-gray-500 italic">
            No logic available
          </p>
        )}
      </div>

      {/* Advisor Recommendations Section */}
      <div>
        <h3 className="text-sm lg:text-base font-semibold text-gray-900 mb-3">
          Advisor Recommendations
        </h3>
        {hasRecommendations ? (
          <ul className="space-y-2">
            {safeRecommendations.map((item, index) => (
              <li
                key={item.id || index}
                className="text-xs lg:text-sm text-gray-700 leading-relaxed"
              >
                • {item.text || ""}
              </li>
            ))}
          </ul>
        ) : (
          <p className="text-xs lg:text-sm text-gray-500 italic">
            No recommendations available
          </p>
        )}
      </div>
    </div>
  );
};

export default Recommendations;
